var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRadioDone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4546 9C16.4546 4.58333 12.8713 1 8.45459 1C4.03792 1 0.45459 4.58333 0.45459 9C0.45459 13.4167 4.03792 17 8.45459 17C12.8713 17 16.4546 13.4167 16.4546 9Z",
    fill: "#7B7D51",
    stroke: "#7B7D51",
    strokeWidth: 0.52381,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4546 5.66669L6.85459 12.3334L4.45459 9.66669",
    fill: "#7B7D51"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4546 5.66669L6.85459 12.3334L4.45459 9.66669",
    stroke: "white",
    strokeWidth: 1.04762,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioDone);
export default __webpack_public_path__ + "static/media/RadioDone.dbfac65f61f1649cd22b08e0e9667762.svg";
export { ForwardRef as ReactComponent };